// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Страница «Статистика» — самодостаточные стили модуля.
   Все токены объявлены на .stats-page, поэтому папку statistics/
   можно перенести в другой проект вместе с этим файлом.
   Тёмная тема берётся из общего data-theme на <html>.
   ============================================================ */

.stats-page {
  --st-bg: #ffffff;
  --st-bg-muted: #f8fafc;
  --st-border: rgba(15, 23, 42, 0.08);
  --st-text: #0f172a;
  --st-text-muted: #64748b;
  --st-accent: #2563eb;
  --st-success: #059669;
  --st-success-bg: rgba(16, 185, 129, 0.12);
  --st-danger: #dc2626;
  --st-danger-bg: rgba(220, 38, 38, 0.12);
  --st-warning: #b45309;
  --st-warning-bg: rgba(245, 158, 11, 0.16);
  --st-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px -16px rgba(15, 23, 42, 0.25);
  --st-radius: 14px;

  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px 0 40px;
  color: var(--st-text);
  font-family: var(--font-body, 'Inter', system-ui, sans-serif);
}

:root[data-theme='dark'] .stats-page {
  --st-bg: #0f172a;
  --st-bg-muted: #131c31;
  --st-border: rgba(148, 163, 184, 0.16);
  --st-text: #f1f5f9;
  --st-text-muted: #94a3b8;
  --st-accent: #3b82f6;
  --st-success: #34d399;
  --st-success-bg: rgba(16, 185, 129, 0.16);
  --st-danger: #f87171;
  --st-danger-bg: rgba(248, 113, 113, 0.16);
  --st-warning: #fbbf24;
  --st-warning-bg: rgba(251, 191, 36, 0.16);
  --st-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

/* ── Шапка ── */
.stats-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.stats-page-title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.stats-page-subtitle {
  margin: 6px 0 0;
  color: var(--st-text-muted);
  font-size: 0.92rem;
}

.stats-page-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── Кнопки и мелкие элементы ── */
.stats-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid var(--st-border);
  background: var(--st-bg);
  color: var(--st-text);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.stats-btn:hover {
  background: var(--st-bg-muted);
  transform: translateY(-1px);
}

.stats-btn--primary {
  background: var(--st-text);
  border-color: var(--st-text);
  color: var(--st-bg);
}

.stats-btn--primary:hover {
  background: var(--st-text);
  opacity: 0.9;
}

.stats-btn--solid {
  background: var(--st-bg-muted);
}

.stats-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: 0 0 9px;
}

.stats-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid var(--st-border);
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
}

.stats-badge--up {
  color: var(--st-success);
}

.stats-badge--down {
  color: var(--st-danger);
}

/* ── Карточки ── */
.stats-card {
  background: var(--st-bg);
  border: 1px solid var(--st-border);
  border-radius: var(--st-radius);
  box-shadow: var(--st-shadow);
  padding: 20px 22px;
  min-width: 0;
}

.stats-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.stats-card-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.stats-card-subtitle {
  margin: 4px 0 0;
  color: var(--st-text-muted);
  font-size: 0.85rem;
}

.stats-card-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── KPI ── */
.stats-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.stats-kpi {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stats-kpi-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.stats-kpi-title {
  color: var(--st-text-muted);
  font-size: 0.88rem;
  font-weight: 600;
}

.stats-kpi-value {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.1;
}

.stats-kpi-foot {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stats-kpi-caption {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 600;
}

.stats-kpi-hint {
  color: var(--st-text-muted);
  font-size: 0.82rem;
}

/* ── Сетка карточек ── */
.stats-grid-2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 20px;
}

.stats-chart-card {
  display: flex;
  flex-direction: column;
}

.stats-chart {
  width: 100%;
  min-width: 0;
}

/* ── Выпадающий список ── */
.stats-dropdown {
  position: relative;
}

.stats-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid var(--st-border);
  background: var(--st-bg);
  color: var(--st-text);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.stats-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 30;
  min-width: 200px;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid var(--st-border);
  background: var(--st-bg);
  box-shadow: 0 12px 32px -12px rgba(15, 23, 42, 0.35);
}

.stats-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--st-text);
  font-size: 0.85rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

.stats-dropdown-item:hover,
.stats-dropdown-item.active {
  background: var(--st-bg-muted);
}

/* ── Тултип графиков ── */
.stats-tooltip {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid var(--st-border);
  background: var(--st-bg);
  box-shadow: 0 12px 32px -14px rgba(15, 23, 42, 0.45);
  font-size: 0.8rem;
}

.stats-tooltip-title {
  margin-bottom: 6px;
  font-weight: 700;
}

.stats-tooltip-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stats-tooltip-name {
  color: var(--st-text-muted);
}

.stats-tooltip-value {
  margin-left: auto;
  font-weight: 700;
}

/* ── Пончик ── */
.stats-donut-layout {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) minmax(240px, 1.1fr);
  align-items: center;
  gap: 20px;
}

.stats-donut {
  position: relative;
  min-width: 0;
}

.stats-donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.stats-donut-value {
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.stats-donut-label {
  color: var(--st-text-muted);
  font-size: 0.78rem;
}

.stats-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stats-legend-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.stats-legend-row:hover,
.stats-legend-row.active {
  background: var(--st-bg-muted);
}

.stats-legend-name {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 0.92rem;
}

.stats-legend-values {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.stats-legend-amount {
  font-weight: 700;
}

.stats-legend-share {
  color: var(--st-text-muted);
  font-size: 0.78rem;
}

/* ── Списки строк (транзакции, товары) ── */
.stats-rows {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stats-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--st-border);
  border-radius: 12px;
  background: var(--st-bg-muted);
  min-width: 0;
}

.stats-avatar,
.stats-rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-radius: 50%;
  background: var(--st-bg);
  border: 1px solid var(--st-border);
  font-size: 0.75rem;
  font-weight: 700;
}

.stats-rank {
  border-radius: 10px;
}

.stats-row-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
}

.stats-row-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 0.92rem;
  overflow-wrap: anywhere;
}

.stats-row-sub {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--st-text-muted);
  font-size: 0.8rem;
  overflow-wrap: anywhere;
}

.stats-row-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  white-space: nowrap;
}

.stats-row-amount-line {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.stats-row-amount {
  font-weight: 700;
}

.stats-row-more {
  border: none;
  background: transparent;
  color: var(--st-text-muted);
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
}

.stats-row-more:hover {
  background: var(--st-bg);
}

.stats-tag {
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--st-border);
  background: var(--st-bg);
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--st-text-muted);
}

.stats-status {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 700;
  white-space: nowrap;
}

.stats-status--completed {
  background: var(--st-success-bg);
  color: var(--st-success);
}

.stats-status--pending {
  background: var(--st-warning-bg);
  color: var(--st-warning);
}

.stats-status--failed {
  background: var(--st-danger-bg);
  color: var(--st-danger);
}

.stats-stock {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stats-progress {
  display: block;
  width: 80px;
  height: 5px;
  border-radius: 999px;
  background: var(--st-border);
  overflow: hidden;
}

.stats-progress-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: var(--st-text);
}

/* ── Вкладки и аналитика по клиентам ── */
.stats-tabs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 5px;
  border-radius: 12px;
  background: var(--st-bg-muted);
  border: 1px solid var(--st-border);
  margin-bottom: 20px;
}

.stats-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: var(--st-text-muted);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.stats-tab.active {
  background: var(--st-bg);
  border-color: var(--st-border);
  color: var(--st-text);
}

.stats-insights-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(240px, 1fr);
  gap: 20px;
}

.stats-block-title {
  margin: 0 0 14px;
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--st-text-muted);
}

.stats-distribution-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.stats-distribution-list li {
  display: grid;
  grid-template-columns: 130px 1fr 48px;
  align-items: center;
  gap: 12px;
}

.stats-distribution-list .stats-progress {
  width: 100%;
  height: 8px;
}

.stats-distribution-label {
  font-size: 0.88rem;
  font-weight: 600;
}

.stats-distribution-value {
  text-align: right;
  font-weight: 700;
  font-size: 0.88rem;
}

.stats-insights-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stats-metric {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  border: 1px solid var(--st-border);
  border-radius: 12px;
  background: var(--st-bg-muted);
}

.stats-metric-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--st-text-muted);
  font-size: 0.82rem;
  font-weight: 600;
}

.stats-metric-value {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.stats-metric-delta {
  color: var(--st-success);
  font-size: 0.8rem;
  font-weight: 600;
}

/* ── Адаптив ── */
@media (max-width: 1100px) {
  .stats-grid-2,
  .stats-insights-grid,
  .stats-donut-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .stats-page-title {
    font-size: 1.4rem;
  }

  .stats-row {
    flex-wrap: wrap;
  }

  .stats-row-meta {
    align-items: flex-start;
  }

  .stats-tabs {
    grid-template-columns: 1fr;
  }

  .stats-distribution-list li {
    grid-template-columns: 90px 1fr 42px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/statistics/statistics.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,yCAAyC;EACzC,oBAAoB;EACpB,uCAAuC;EACvC,qBAAqB;EACrB,yCAAyC;EACzC,sFAAsF;EACtF,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,yCAAyC;EACzC,oBAAoB;EACpB,yCAAyC;EACzC,qBAAqB;EACrB,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oCAAoC;EACtC;AACF","sourcesContent":["/* ============================================================\n   Страница «Статистика» — самодостаточные стили модуля.\n   Все токены объявлены на .stats-page, поэтому папку statistics/\n   можно перенести в другой проект вместе с этим файлом.\n   Тёмная тема берётся из общего data-theme на <html>.\n   ============================================================ */\n\n.stats-page {\n  --st-bg: #ffffff;\n  --st-bg-muted: #f8fafc;\n  --st-border: rgba(15, 23, 42, 0.08);\n  --st-text: #0f172a;\n  --st-text-muted: #64748b;\n  --st-accent: #2563eb;\n  --st-success: #059669;\n  --st-success-bg: rgba(16, 185, 129, 0.12);\n  --st-danger: #dc2626;\n  --st-danger-bg: rgba(220, 38, 38, 0.12);\n  --st-warning: #b45309;\n  --st-warning-bg: rgba(245, 158, 11, 0.16);\n  --st-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px -16px rgba(15, 23, 42, 0.25);\n  --st-radius: 14px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 8px 0 40px;\n  color: var(--st-text);\n  font-family: var(--font-body, 'Inter', system-ui, sans-serif);\n}\n\n:root[data-theme='dark'] .stats-page {\n  --st-bg: #0f172a;\n  --st-bg-muted: #131c31;\n  --st-border: rgba(148, 163, 184, 0.16);\n  --st-text: #f1f5f9;\n  --st-text-muted: #94a3b8;\n  --st-accent: #3b82f6;\n  --st-success: #34d399;\n  --st-success-bg: rgba(16, 185, 129, 0.16);\n  --st-danger: #f87171;\n  --st-danger-bg: rgba(248, 113, 113, 0.16);\n  --st-warning: #fbbf24;\n  --st-warning-bg: rgba(251, 191, 36, 0.16);\n  --st-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n}\n\n/* ── Шапка ── */\n.stats-page-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.stats-page-title {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.stats-page-subtitle {\n  margin: 6px 0 0;\n  color: var(--st-text-muted);\n  font-size: 0.92rem;\n}\n\n.stats-page-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* ── Кнопки и мелкие элементы ── */\n.stats-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid var(--st-border);\n  background: var(--st-bg);\n  color: var(--st-text);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n.stats-btn:hover {\n  background: var(--st-bg-muted);\n  transform: translateY(-1px);\n}\n\n.stats-btn--primary {\n  background: var(--st-text);\n  border-color: var(--st-text);\n  color: var(--st-bg);\n}\n\n.stats-btn--primary:hover {\n  background: var(--st-text);\n  opacity: 0.9;\n}\n\n.stats-btn--solid {\n  background: var(--st-bg-muted);\n}\n\n.stats-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  flex: 0 0 9px;\n}\n\n.stats-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--st-border);\n  font-size: 0.72rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.stats-badge--up {\n  color: var(--st-success);\n}\n\n.stats-badge--down {\n  color: var(--st-danger);\n}\n\n/* ── Карточки ── */\n.stats-card {\n  background: var(--st-bg);\n  border: 1px solid var(--st-border);\n  border-radius: var(--st-radius);\n  box-shadow: var(--st-shadow);\n  padding: 20px 22px;\n  min-width: 0;\n}\n\n.stats-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n\n.stats-card-title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.stats-card-subtitle {\n  margin: 4px 0 0;\n  color: var(--st-text-muted);\n  font-size: 0.85rem;\n}\n\n.stats-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* ── KPI ── */\n.stats-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.stats-kpi {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.stats-kpi-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.stats-kpi-title {\n  color: var(--st-text-muted);\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.stats-kpi-value {\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n}\n\n.stats-kpi-foot {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stats-kpi-caption {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.stats-kpi-hint {\n  color: var(--st-text-muted);\n  font-size: 0.82rem;\n}\n\n/* ── Сетка карточек ── */\n.stats-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\n  gap: 20px;\n}\n\n.stats-chart-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.stats-chart {\n  width: 100%;\n  min-width: 0;\n}\n\n/* ── Выпадающий список ── */\n.stats-dropdown {\n  position: relative;\n}\n\n.stats-dropdown-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 12px;\n  border-radius: 10px;\n  border: 1px solid var(--st-border);\n  background: var(--st-bg);\n  color: var(--st-text);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.stats-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 30;\n  min-width: 200px;\n  padding: 6px;\n  border-radius: 12px;\n  border: 1px solid var(--st-border);\n  background: var(--st-bg);\n  box-shadow: 0 12px 32px -12px rgba(15, 23, 42, 0.35);\n}\n\n.stats-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--st-text);\n  font-size: 0.85rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n}\n\n.stats-dropdown-item:hover,\n.stats-dropdown-item.active {\n  background: var(--st-bg-muted);\n}\n\n/* ── Тултип графиков ── */\n.stats-tooltip {\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid var(--st-border);\n  background: var(--st-bg);\n  box-shadow: 0 12px 32px -14px rgba(15, 23, 42, 0.45);\n  font-size: 0.8rem;\n}\n\n.stats-tooltip-title {\n  margin-bottom: 6px;\n  font-weight: 700;\n}\n\n.stats-tooltip-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.stats-tooltip-name {\n  color: var(--st-text-muted);\n}\n\n.stats-tooltip-value {\n  margin-left: auto;\n  font-weight: 700;\n}\n\n/* ── Пончик ── */\n.stats-donut-layout {\n  display: grid;\n  grid-template-columns: minmax(200px, 1fr) minmax(240px, 1.1fr);\n  align-items: center;\n  gap: 20px;\n}\n\n.stats-donut {\n  position: relative;\n  min-width: 0;\n}\n\n.stats-donut-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.stats-donut-value {\n  font-size: 1.6rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.stats-donut-label {\n  color: var(--st-text-muted);\n  font-size: 0.78rem;\n}\n\n.stats-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stats-legend-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.stats-legend-row:hover,\n.stats-legend-row.active {\n  background: var(--st-bg-muted);\n}\n\n.stats-legend-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n  font-size: 0.92rem;\n}\n\n.stats-legend-values {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.stats-legend-amount {\n  font-weight: 700;\n}\n\n.stats-legend-share {\n  color: var(--st-text-muted);\n  font-size: 0.78rem;\n}\n\n/* ── Списки строк (транзакции, товары) ── */\n.stats-rows {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.stats-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--st-border);\n  border-radius: 12px;\n  background: var(--st-bg-muted);\n  min-width: 0;\n}\n\n.stats-avatar,\n.stats-rank {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  flex: 0 0 36px;\n  border-radius: 50%;\n  background: var(--st-bg);\n  border: 1px solid var(--st-border);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.stats-rank {\n  border-radius: 10px;\n}\n\n.stats-row-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.stats-row-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 0.92rem;\n  overflow-wrap: anywhere;\n}\n\n.stats-row-sub {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--st-text-muted);\n  font-size: 0.8rem;\n  overflow-wrap: anywhere;\n}\n\n.stats-row-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.stats-row-amount-line {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.stats-row-amount {\n  font-weight: 700;\n}\n\n.stats-row-more {\n  border: none;\n  background: transparent;\n  color: var(--st-text-muted);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.stats-row-more:hover {\n  background: var(--st-bg);\n}\n\n.stats-tag {\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--st-border);\n  background: var(--st-bg);\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--st-text-muted);\n}\n\n.stats-status {\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.74rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.stats-status--completed {\n  background: var(--st-success-bg);\n  color: var(--st-success);\n}\n\n.stats-status--pending {\n  background: var(--st-warning-bg);\n  color: var(--st-warning);\n}\n\n.stats-status--failed {\n  background: var(--st-danger-bg);\n  color: var(--st-danger);\n}\n\n.stats-stock {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.stats-progress {\n  display: block;\n  width: 80px;\n  height: 5px;\n  border-radius: 999px;\n  background: var(--st-border);\n  overflow: hidden;\n}\n\n.stats-progress-fill {\n  display: block;\n  height: 100%;\n  border-radius: 999px;\n  background: var(--st-text);\n}\n\n/* ── Вкладки и аналитика по клиентам ── */\n.stats-tabs {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 6px;\n  padding: 5px;\n  border-radius: 12px;\n  background: var(--st-bg-muted);\n  border: 1px solid var(--st-border);\n  margin-bottom: 20px;\n}\n\n.stats-tab {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--st-text-muted);\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.stats-tab.active {\n  background: var(--st-bg);\n  border-color: var(--st-border);\n  color: var(--st-text);\n}\n\n.stats-insights-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(240px, 1fr);\n  gap: 20px;\n}\n\n.stats-block-title {\n  margin: 0 0 14px;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: var(--st-text-muted);\n}\n\n.stats-distribution-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.stats-distribution-list li {\n  display: grid;\n  grid-template-columns: 130px 1fr 48px;\n  align-items: center;\n  gap: 12px;\n}\n\n.stats-distribution-list .stats-progress {\n  width: 100%;\n  height: 8px;\n}\n\n.stats-distribution-label {\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.stats-distribution-value {\n  text-align: right;\n  font-weight: 700;\n  font-size: 0.88rem;\n}\n\n.stats-insights-side {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.stats-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 14px 16px;\n  border: 1px solid var(--st-border);\n  border-radius: 12px;\n  background: var(--st-bg-muted);\n}\n\n.stats-metric-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--st-text-muted);\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.stats-metric-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.stats-metric-delta {\n  color: var(--st-success);\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n/* ── Адаптив ── */\n@media (max-width: 1100px) {\n  .stats-grid-2,\n  .stats-insights-grid,\n  .stats-donut-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .stats-page-title {\n    font-size: 1.4rem;\n  }\n\n  .stats-row {\n    flex-wrap: wrap;\n  }\n\n  .stats-row-meta {\n    align-items: flex-start;\n  }\n\n  .stats-tabs {\n    grid-template-columns: 1fr;\n  }\n\n  .stats-distribution-list li {\n    grid-template-columns: 90px 1fr 42px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
